import { FC, useRef } from "react"
import { useAtom, useAtomValue } from "jotai"
import { useTar } from "@/modules/i18n"
import { WysiwygEditor } from "@/components/WysiwygEditor"
import { workspaceChallengeIdAtom } from "@/store/workspaceAtoms"
import { currentNotesAtom } from "@/store/saveWorkAtoms"
import { useDebouncedWorkSaver } from "@/hooks/useDebouncedWorkSaver"

export const NotesTab: FC = () => {
    const { t } = useTar()
    const challengeId = useAtomValue(workspaceChallengeIdAtom)
    const [notes, setNotes] = useAtom(currentNotesAtom)
    const notesRef = useRef(notes)
    notesRef.current = notes

    const { schedule: scheduleWorkSave } = useDebouncedWorkSaver(challengeId)

    return (
        <div className="h-full min-h-full flex flex-col overflow-hidden">
            <WysiwygEditor
                telemetrySurface="notes"
                content={notes}
                contentGetter={() => notesRef.current}
                onChange={(newNotes) => {
                    setNotes(newNotes)
                    scheduleWorkSave({ notes: newNotes })
                }}
                placeholder={t('common.notes')}
                className="max-w-none flex-1 min-h-0 p-0"
            />
        </div>
    )
}
